import { reduce } from './';
var bulletList = function bulletList(node, schema) {
  var result = [];
  node.forEach(function (n) {
    result.push("* ".concat(reduce(n, schema)));
  });
  return result.join('\n');
};
export default bulletList;